import { graphql } from 'gatsby';
import TeamPage from '../views/team';

export default TeamPage;

export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    
    teamMembers: allContentfulTeamMember {
      edges {
        node {
          name
          department
          role
          photo {
            title
            file {
              url
            }
          }
          linkedin
          email
          telephone
          description {
            description
          }
          node_locale
        }
      }
    }
  }
`;
